module.exports = __webpack_public_path__ + "img/ge_lang.8d3b5d7b.png";